export { default as ArrowNarrowUpSolidIcon } from './ArrowNarrowUpSolidIcon';
